import { get_resource_uri } from "../util/cache_buster";

import { TranslationIndex } from './translation_index';
import { TranslationManager } from './translation_manager';

import { storeLocale, resolveLocale } from './locale';

const I18N_PATH = "i18n";
const I18N_INDEX = `${I18N_PATH}/index.json`;

const loadSystemIndex = async () => {
	const index = get_resource_uri(I18N_INDEX);
	
	const result = await fetch(index);
	const data = await result.json();
	return data;
}

class ReadOnlyStorage {
	
	constructor(manager) {
		this.manager = manager;
	}
	
	get locale() {
		return this.manager.locale;
	}
	
	updateLocale(requestedLocale, persist) {
		return this.manager.updateSystemLocale(requestedLocale, persist);
	}
	
}

// keeps the global system translation
// and current state of translation
class I18NManager {

	constructor() {
		this.index = undefined;
		this.locale = undefined;
		this.locales = undefined;
		this.instance = undefined;
	}
	
	async init(requestedLocale, translations) {
		const systemInstance = await this.initSystem(requestedLocale);
		return systemInstance.init(translations);
	}
	
	async initSystem(requestedLocale) {
		if( this.locale === undefined ) {
			const { defaultLocale, locales, dependencies } = await loadSystemIndex();

			this.locales = locales;

			this.index = new TranslationIndex({
				defaultLocale: defaultLocale,
				locales: Object.keys(locales),
				dependencies: dependencies
			});
			
			const resolvedLocale = resolveLocale(requestedLocale, new Set(this.index.locales));
						
			// ensure default fallback locale
			await this.checkSystemTranslation( this.index.defaultLocale );
			
			// check the requested locale
			await this.checkSystemTranslation( resolvedLocale );
		}
		
		// create instance
		this.instance = new TranslationManager({
			storage: new ReadOnlyStorage(this),
			index: this.index.copyOf()
		});
		
		return this.instance;
	}
	
	async checkSystemTranslation(locale) {
		const resolvedLocale = this.index.getLocale( locale );
		
		if( !this.index.hasTranslationLocale(resolvedLocale) ) {
			const translation = await this.loadSystemTranslation(resolvedLocale);
		
			Object.entries(translation)
			.forEach(([key, value]) => {
				this.index.addTranslation(resolvedLocale, key, value);
			})
		}

        this.locale = resolvedLocale;
    }

    async loadSystemTranslation (locale) {
        const uri = `${I18N_PATH}/${this.locales[locale]}`;

        const result = await fetch(uri);
        const translations = await result.json();

        return translations;
    }

    async updateSystemLocale(requestedLocale, persist) {
        await this.checkSystemTranslation(requestedLocale);

        if (persist) {
            storeLocale(this.locale);
        }

        return {
            locale: this.locale,
            translations: this.index.translations[this.locale]
        };
    }

}

export {
    I18NManager, I18N_PATH
}